export default __webpack_public_path__ + "static/media/no-eye.87a0d7a6.svg";